import type { ThemeConfig } from "antd";

export const jobsTheme: ThemeConfig = {
  token: {
    colorPrimary: "#723EC7",
    colorPrimaryBg: "#F6F8FB",
    colorPrimaryBgHover: "#C7A9E7",
    colorPrimaryBorder: "#C7A9E7",
    colorPrimaryBorderHover: "#8C59D6",
    colorPrimaryHover: "#9D6ED7",
    colorPrimaryActive: "#723EC7",
    colorPrimaryTextHover: "#391085",
    colorPrimaryText: "#110138",
    colorPrimaryTextActive: "#050012",
    colorLinkHover: "#722ED1",
    colorLinkActive: "#9D6ED7",
    colorLink: "#723EC7",
  },
  components: {
    Avatar: {
      containerSize: 52,
      containerSizeLG: 100,
    },
    Layout: {
      bodyBg: "#F6F8FB",
    },
    Form: {
      labelColor: "rgba(0,0,0,0.45)",
    },
  },
};

export const Z_INDEX = {
  HEADER: 4,
  FLOATING_NAV: 5,
  BANNER: 3,
  DEFAULT: 2,
} as const;
